import React from 'react';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './DashboardLayout.css';
import { useAuth } from '../../context/AuthContext';

const DashboardLayout = ({ children }) => {
  const { tenant } = useAuth();

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="dashboard-main">
        <Header />

        <main className="dashboard-content">
          {tenant && (
            <div className="tenant-banner">
              Tenant: <span>{tenant.name}</span>
            </div>
          )}

          <div className="dashboard-inner">
            {children}
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
